export default {
  functional: true,

  render(h, { parent, children }) {
    parent.$once('hook:mounted', () => {
      parent.$forceUpdate()
    })

    return children
  }
}
